import { MessageSquare, Handshake, ClipboardCheck } from "lucide-react";

const actions = [
  { icon: MessageSquare, title: "Reestabelecer diálogo", desc: "Diálogo estratégico entre sócios. Separar conflito relacional de decisão empresarial." },
  { icon: Handshake, title: "Resgatar acordos", desc: "Atualizar o que não faz mais sentido. Definir regras claras de responsabilidade, papéis e alçadas." },
  { icon: ClipboardCheck, title: "Implementar modelo decisório", desc: "Um modelo decisório que evite novos impasses e garanta agilidade." },
];

const HowWeActSection = () => (
  <section className="section-dark py-14 md:py-20">
    <div className="container mx-auto px-6">
      <div className="max-w-3xl mx-auto text-center mb-6">
        <p className="text-primary font-body font-semibold tracking-widest uppercase text-[13px] mb-5">Solução</p>
        <h2 className="text-[25px] md:text-[31px] lg:text-[39px] font-heading font-bold leading-[1.2em] tracking-[-1px] mb-6 text-surface-dark-foreground">O que fazer?</h2>
        <p className="text-[16px] text-surface-dark-foreground/70 font-body font-normal mb-2 leading-[1.5em]">
          Conflitos societários não se resolvem com conversa informal.
        </p>
        <p className="text-[16px] text-surface-dark-foreground/90 font-body font-semibold leading-[1.5em]">
          Eles exigem intermediação estruturada, independente e orientada à decisão.
        </p>
      </div>

      <div className="max-w-3xl mx-auto text-center mt-14 mb-12">
        <h3 className="text-[22px] md:text-[25px] lg:text-[31.25px] font-heading font-bold leading-[1.3em] tracking-[-1px] text-surface-dark-foreground mb-3">Como Atuamos</h3>
        <p className="text-surface-dark-foreground/70 font-body text-[16px] font-normal leading-[1.5em]">
          Intermediação de Conflito Societário com método, neutralidade e foco em decisão.
        </p>
        <p className="text-surface-dark-foreground/60 font-body mt-2 text-[14px] font-normal leading-[1.5em]">
          Criamos um espaço seguro e conduzimos ações para:
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
        {actions.map((action, i) => (
          <div key={i} className="text-center">
            <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-5">
              <action.icon className="w-7 h-7 text-primary" />
            </div>
            <h4 className="font-heading text-[20px] font-bold leading-[1.4em] tracking-[-0.5px] text-surface-dark-foreground mb-3">{action.title}</h4>
            <p className="text-surface-dark-foreground/70 font-body text-[14px] font-normal leading-[1.5em]">{action.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HowWeActSection;
